import { render, staticRenderFns } from "./SupplierCreateEditModal.vue?vue&type=template&id=36729498&"
import script from "./SupplierCreateEditModal.vue?vue&type=script&lang=js&"
export * from "./SupplierCreateEditModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports